import React from "react";

import { Button, ButtonGroup, Tooltip } from "@/components/ui";
import { cn } from "@/lib/utils";

import { EditorQueueFilter } from "./assigneeFilter";

const QUEUE_OPTIONS: { value: EditorQueueFilter; label: string; tooltip: string }[] = [
  { value: "mine", label: "Mine", tooltip: "Projects assigned to you, or from Coaches on your editing/QA queue" },
  { value: "general", label: "General", tooltip: "Coaches with no queue assignments" },
  { value: "all", label: "All", tooltip: "Every project in the queue" },
];

interface QueueFilterProps {
  value: EditorQueueFilter;
  onChange: (value: EditorQueueFilter) => void;
}

export function QueueFilter({ value, onChange }: QueueFilterProps) {
  return (
    <ButtonGroup className="bg-white border border-slate-200 rounded-lg p-0.5" aria-label="Queue">
      {QUEUE_OPTIONS.map(option => {
        const selected = value === option.value;
        return (
          <Tooltip key={option.value}>
            <Tooltip.Trigger
              render={
                <Button
                  variant={selected ? "secondary" : "ghost"}
                  size="sm"
                  aria-pressed={selected}
                  className={cn(selected && "shadow-xs")}
                  onClick={() => onChange(option.value)}
                >
                  {option.label}
                </Button>
              }
            />
            <Tooltip.Content>{option.tooltip}</Tooltip.Content>
          </Tooltip>
        );
      })}
    </ButtonGroup>
  );
}
